const prefix = 'fieldset';
export const dataHooks = {
    suffix: `${prefix}-suffix`,
    labelIndicators: `${prefix}-indicators`,
    counter: `${prefix}-counter`,
    children: `${prefix}-children`,
    label: `${prefix}-label`,
    asterisk: `${prefix}-asterisk`,
    infoIcon: `${prefix}-infoicon`,
    statusMessage: `${prefix}-statusmessage`,
};
export const LEGEND_PLACEMENT = {
    NONE: 'none',
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
};
export const LEGEND_ALIGNMENT = {
    MIDDLE: 'middle',
    TOP: 'top',
};
export const STATUS_TYPE = {
    ERROR: 'error',
    WARNING: 'warning',
};
export const LEGEND_SIZE = {
    SMALL: 'small',
    TINY: 'tiny',
};
export const ALIGNMENT = {
    START: 'start',
    CENTER: 'center',
    END: 'end',
};
export const DIRECTION = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
export const GAP = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
//# sourceMappingURL=constants.js.map